import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    headerSortingClasses,
} from "../../../../_metronic/_helpers";
import { useSubheader } from "../../../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, baseURL } from "../../../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { temp_store } from "../../../modules/function/temp_store"
import { useIntl } from "react-intl";

export const EditSpecCompare = (props) => {
    const intl = useIntl();

    const suhbeader = useSubheader();
    const allData = [];
    const [templateData, setTemplateData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalSize, setTotalSize] = useState(100);
    const [is_loading, setIs_Loading] = useState(false);
    const [listError, setlistError] = useState(false);
    suhbeader.setTitle("Edit SpecCompare Details");
    const { user } = useSelector((state) => state.auth);
    const [listMasterModel, setListMasterModel] = useState([]);
    const history = useHistory();
    const [id, setID] = useState();

    useEffect(() => {
        // console.log(temp_store(props).location.state.row)
        getListMasterModel(page, limit, temp_store(props).location.state.row.id);
        console.log(temp_store(props).location.state)

    }, []);


    const getListMasterModel = async (page, limit, id) => {
        setIs_Loading(true);
        const apiUrls = `${baseURLV1}/specvalue/${id}/?page=${page}&limit=${limit}`; // รอแก้
        axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${user.data.access_token}`,
            },
        })
            .then((res) => {
                setListMasterModel(res.data.data);
                setIs_Loading(false);
                setlistError(false);

                var totalpage = Math.ceil(res.data.total / res.data.limit);
                setTotalPage(totalpage);
                setTotalSize(res.data.total);
                setLimit(res.data.limit);
                setTemplateData(allData);

            })
            .catch((err) => {
                if (err.response) {
                    setIs_Loading(false);
                    setlistError(true);
                }
            });
    };


    const columns = [

        {
            dataField: "speckey.key",
            text: "Key",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "value",
            text: "Value",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            text: "Action",
            dataField: "id",
            formatter: (id, row, rowIndex) => {
                return (
                    <div style={{ width: '150px', alignContent: 'center' }}>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => deleteItem({id, row, rowIndex })}
                        >
                            Delete
                        </button>
                    </div>
                );
            },
        },
    ];

    const deleteItem = (data) => {
        console.log(data)
        Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover this limit point !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.value) {
                axios
                    .delete(`${baseURLV1}/specvalue/${data.row.key_id}?product=${temp_store(props).location.state.row.id}`)
                    .then((res) => {
                        Swal.fire("Deleted!", "Your model has been deleted.", "success");
                        getListMasterModel(page, limit, temp_store(props).location.state.row.id);
                    })
                    .catch((err) => {
                        Swal.fire(
                            "Deleted!",
                            "Your model has been fail to deleted.",
                            "error"
                        );
                    });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelled", "Your model is safe :)", "error");
            }
        });
    };
    const handlePageChange = (event, value) => {
        setPage(value);
        getListMasterModel(value, limit, temp_store(props).location.state.row.id);
    };

    const handlePageSizeChange = (event) => {
        setLimit(event.target.value);
        getListMasterModel(1, event.target.value, temp_store(props).location.state.row.id);
    };

    const editItem = (data) => {
        history.push("/EditSpec", data);
    };

    const createSpec = (data) => {
        history.push("/CreateSpec", { data: data });
    };

    return (
        <Card>
            <CardHeader title="Edit SpecCompare Details">

                <CardHeaderToolbar>

                    <button type="button" onClick={() => createSpec(temp_store(props).location.state.row)} className="btn btn-primary">
                        + Create
                    </button>

                    <button type="button" onClick={() => editItem(listMasterModel)} className="btn btn-primary ml-4">
                        Edit
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Link to="/ProductManagement">
                    <button type="button" className="btn btn-secondary wbt mr-5">
                        {intl.formatMessage({ id: "104047", defaultMessage: "Back" })}
                    </button>
                </Link>


                {/* /Search Btn/ */}

                {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}


                <BootstrapTable
                    keyField="id"
                    data={listMasterModel}
                    columns={columns}
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                />
                <div className=" col-lg-12">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mt-3">
                                {"Items per Page: "}
                                <select onChange={handlePageSizeChange} value={limit}>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <Pagination2
                                className="mt-3 "
                                count={totalPage}
                                page={page}
                                siblingCount={1}
                                boundaryCount={1}
                                variant="outlined"
                                shape="rounded"
                                onChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>

            </CardBody>
        </Card>
    );
};
